import React from 'react';
import styled from 'astroturf/react';

const Container = styled.div`
  background: #fff;
  border: 1px solid #ddd;
  column-gap: 16px;
  height: 204px;
  margin-bottom: 24px;
  padding: 16px 20px;
`;

const Placeholder = styled('div').attrs<{ small?: boolean }>({
  className: 'search-placeholder-loading',
})`
  background: #eee;
  border-radius: 48px;
  height: 24px;
  margin-bottom: 12px;
  overflow: hidden;
  position: relative;
  width: 40%;

  &.small {
    border-radius: 32px;
    display: inline-block;
    height: 16px;
    margin-right: 16px;
    width: 12%;
  }

  &::after {
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(128, 128, 128, 0.12) 40%,
      rgba(128, 128, 128, 0.12) 60%,
      transparent 100%
    );
    background-repeat: no-repeat;
    background-size: 50%;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
  }
`;

const LoadingResult = () => (
  <Container>
    <Placeholder />
    <Placeholder small />
    <Placeholder small />
  </Container>
);

const Loading = ({ className }: { className?: string }) => (
  <div className={className}>
    <LoadingResult />
    <LoadingResult />
    <LoadingResult />
    <LoadingResult />
    <LoadingResult />
  </div>
);

export default Loading;
